import { api, helpers } from "../../../utils";
const cafe = {
    default: {
        name: "chrome.runtime.manifest",
        windowId: -1,
        tab: {
            id: -1,
            windowId: -1,
        },
    },
};
const hlog = helpers.html.log;
const df = cafe.default;

const sendMessage = async ({ state, commit }, payload) => {
    let p = new Promise(async (resolve) => {
        hlog.start("store.chrome.runtime.sendMessage", "start", payload);
        let res = await api.chrome.runtime.sendMessage(payload);
        let windowId = state.windowId || df.windowId;
        let tab = state.tab || df.tab;
        if (res.is_success && payload.name === df.name) {
            tab = res.data.tab || tab;
            windowId = tab.windowId;
        };
        let data = { windowId, tab };
        hlog.end("store.chrome.runtime.sendMessage", "end", res);
        commit({ type: "loadData", data });
        resolve(res);
    });

    return p;
};

export default {
    sendMessage,
};



// WEBPACK FOOTER //
// src/store/chrome/runtime/actions.js